import { useEffect } from 'react';
import { trackUpscTopicDetails } from './upscCurrentAffairsAnalytics';
import UpscTopicContentBlocksList from './UpscTopicContentBlocksList';
import { UpscCurrentAffairsTopicArticle } from './upscCurrentAffairsTopicTypes';

export interface UpscCurrentAffairsDetailedPageContentProps {
  article: UpscCurrentAffairsTopicArticle;
}

const UpscCurrentAffairsDetailedPageContent = ({
  article
}: UpscCurrentAffairsDetailedPageContentProps) => {
  useEffect(() => {
    trackUpscTopicDetails({
      topicId: article.id,
      topicTitle: article.topicHeading,
      topicDate: article.publishAt,
      subjectName: article.upscSubject?.heading
    });
  }, [
    article.id,
    article.topicHeading,
    article.publishAt,
    article.upscSubject?.heading
  ]);

  return <UpscTopicContentBlocksList contentBlocks={article.contentBlocks} />;
};

export default UpscCurrentAffairsDetailedPageContent;
